import React, { FC, useState } from 'react';
import Image from 'next/image';
import styled from 'styled-components';

import Button from '@/components/Button/Button';
import fasad from '@/public/fasad.webp';
import { devices } from '@/styles/breakpoints';
import { TitleH2 } from '@/styles/typography';
import { RegularText } from '@/styles/typography';

interface IProps {
  title: string;
  subTitle: string;
  items: [title: string, icon: string];
  revert: boolean;
  image: {
    imageMob: string;
    imageDesk: string;
  };
}

const Item = ({ item }) => {
  const Icon = item.icon;
  return (
    <ListItem>
      {item?.icon && (
        <ListItemicon>
          <Icon />
        </ListItemicon>
      )}

      <RegularText>{item.title}</RegularText>
    </ListItem>
  );
};

export const WhatIs: FC<IProps> = ({
  title,
  subTitle,
  items,
  image,
  revert = false,
  isVideo = false,
  secondaryText,
  thirdText,
  fouthText,
}) => {
  const [click, setClick] = useState(false);

  // const url =
  //   'https://s3.us-west-1.amazonaws.com/app.orcatec.storage/storage_61/media/In47Uz7VM0HE1DkcxGhgMNnUJSSQq1RIySCcfiPB.mp4';

  return (
    <Wrapper $revert={revert}>
      <ImageWrapper>
        {isVideo ? (
          click ? (
            <iframe
              src="https://www.youtube.com/embed/X9F3eDN7jlA"
              title="YouTube video player"
              style={{
                borderRadius: '10px',
                border: 'none',
              }}
              className="video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <Image
              className="fasad-image"
              onClick={() => setClick(true)}
              src={fasad}
              alt="YouTube video player"
              style={{ cursor: 'pointer' }}
            />
          )
        ) : (
          <>
            {' '}
            <div
              style={
                image?.height
                  ? { display: 'flex', alignItems: 'center', height: '100%' }
                  : {}
              }
              className="desc"
            >
              <Image
                src={image.imageDesk}
                alt="image"
                width={536}
                height={620}
                style={{ height: image?.height }}
              />
            </div>
            <div className="mob">
              <Image
                src={image.imageMob}
                alt="image"
                width={334}
                height={200}
              />
            </div>
          </>
        )}
      </ImageWrapper>
      <ContentWrapper>
        <Title>{title}</Title>
        {subTitle && (
          <Description>
            {subTitle}
            {secondaryText && (
              <>
                <Description style={{ paddingTop: '16px' }}>
                  {secondaryText}
                </Description>{' '}
              </>
            )}
            {thirdText && (
              <>
                <Description style={{ paddingTop: '16px' }}>
                  {thirdText}
                </Description>{' '}
              </>
            )}
            {fouthText && (
              <>
                <Description style={{ paddingTop: '16px' }}>
                  {fouthText}
                </Description>{' '}
              </>
            )}
          </Description>
        )}

        {!!items?.length && (
          <ListItems>
            {items.map((item, idx) => (
              <Item key={idx} item={item} />
            ))}
          </ListItems>
        )}

        <Button
          onClick={() =>
            window.open('https://app.orcatec.com/auth/signup', 'e_blank')
          }
          variant="secondary"
        >
          <p>Start using</p>
        </Button>
      </ContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 12px;
  @media only screen and ${devices.desktop} {
    flex-direction: ${(props) => (props.$revert ? 'row-reverse' : 'row')};
    justify-content: space-between;
    gap: 56px;
    padding-top: 40px;
  }
`;

const Title = styled(TitleH2)`
  margin-bottom: 8px;
  text-align: left;
  @media only screen and ${devices.desktop} {
    margin-bottom: 13px;
  }
`;

const Description = styled(RegularText)`
  @media only screen and ${devices.desktop} {
    margin-bottom: 24px;
  }
`;

const ImageWrapper = styled.div`
  & .desc {
    display: none !important;
  }
  & img {
    border-radius: 10px;
  }

  & .fasad-image {
    width: 100% !important;
  }
  & video,
  iframe,
  .fasad-image {
    border-radius: 10px;
    width: 354px;
    height: 220px;
    display: block;
    margin: 0 auto;
    object-fit: cover;
    @media only screen and ${devices.desktop} {
      width: 536px;
      height: 620px;
    }
  }
  @media only screen and ${devices.desktop} {
    width: 100%;
    & .desc {
      display: block !important;
    }
    & .mob {
      display: none;
    }
  }

  & .mob img {
    display: block;
    width: 100% !important;
    height: auto !important;
    margin: 0 auto;
  }
`;

const ContentWrapper = styled.div`
  & button {
    width: 100%;
  }
  display: flex;
  align-items: start;

  flex-direction: column;
  row-gap: 16px;
  line-height: 0;
  @media only screen and ${devices.desktop} {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    /* padding-top: 38px; */
    /* gap: 16px; */
    & button {
      width: 168px;
    }
  }
`;

const ListItems = styled.ul`
  display: flex;
  align-items: start;
  flex-direction: column;

  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  row-gap: 16px;
  width: 100%;
  /* padding-top: 24px; */
  margin-bottom: 10px;
  @media only screen and ${devices.desktop} {
    flex-direction: column;
    align-item: start;
    margin-bottom: 32px;
  }
`;

const ListItem = styled.li`
  width: 100%;
  display: flex;

  align-items: center;
  gap: 16px;
  @media only screen and ${devices.desktop} {
    width: 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
  }
`;

const ListItemicon = styled.div`
  /* margin-bottom: 16px; */
  @media only screen and ${devices.desktop} {
    margin-bottom: 0px;
  }
`;
